import { BasicResult } from "../basic-result";
import { SavedAudit } from "./saved-audit";

export class SavedAuditsResult extends BasicResult {
    public Audits: SavedAudit[] = [];
    constructor(values: Object = {}) {
        super();
        Object.assign(this, values);
        if (values.hasOwnProperty('Audits')) {
            this.Audits = [];
            ((values as SavedAuditsResult)['Audits'] as SavedAudit[]).forEach(element => {
                this.Audits.push(new SavedAudit(element));
            });
        }
    }
}